import type { BlockPlotImportT } from "../../../../../../schema/block/plot";

/** @description Layer template utility function */
export const createLayerTemplate = (
  mark: "scatter" | "line",
): BlockPlotImportT["config"]["layers"][number] => ({
  mark,
  name: undefined,
  encoding: {
    x: { identifier: "", column: "" },
    y: { identifier: "", column: "" },
  },
  zoom: {
    x: { min: null, max: null },
    y: { min: null, max: null },
  },
  rule: {
    x: [
      { label: null, value: null },
      { label: null, value: null },
    ],
    y: [
      { label: null, value: null },
      { label: null, value: null },
    ],
  },
  position: "left",
});
